// Sorting rows held in the page (static array data), by one or more columns in order.
/** Rows sorted by `sort` ({ field: 1 | -1 | 0 }); text compares by locale. Returns a new array. */
export function sortRows(rows, sort) {
    if (!sort || !Object.keys(sort).length)
        return rows;
    return [...rows].sort((a, b) => {
        for (const [k, o] of Object.entries(sort)) {
            if (o == 0 || a[k] === b[k])
                continue;
            // ponytail: the comparison ObjectSearch always used; changing it would reorder existing lists
            return typeof a[k] === 'string'
                ? o * a[k].localeCompare(b[k])
                : o * (a[k] > b[k] ? 1 : -1);
        }
        return 0;
    });
}
